<template>
  <div class="page">
    <div class="card">
      <div class="profile-topbar">
        <div class="badge">Профиль</div>

        <button type="button" class="settings-btn" @click="$router.push('/settings')">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M12 8.5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7Z"
              stroke="currentColor"
              stroke-width="1.8"
            />
            <path
              d="M19.4 15a1 1 0 0 0 .2 1.1l.1.1a1.9 1.9 0 0 1 0 2.7a1.9 1.9 0 0 1-2.7 0l-.1-.1a1 1 0 0 0-1.1-.2a1 1 0 0 0-.6.9V20a2 2 0 0 1-2 2h-1.5a2 2 0 0 1-2-2v-.2a1 1 0 0 0-.6-.9a1 1 0 0 0-1.1.2l-.1.1a1.9 1.9 0 0 1-2.7 0a1.9 1.9 0 0 1 0-2.7l.1-.1a1 1 0 0 0 .2-1.1a1 1 0 0 0-.9-.6H4a2 2 0 0 1-2-2v-1.5a2 2 0 0 1 2-2h.2a1 1 0 0 0 .9-.6a1 1 0 0 0-.2-1.1l-.1-.1a1.9 1.9 0 0 1 0-2.7a1.9 1.9 0 0 1 2.7 0l.1.1a1 1 0 0 0 1.1.2a1 1 0 0 0 .6-.9V4a2 2 0 0 1 2-2h1.5a2 2 0 0 1 2 2v.2a1 1 0 0 0 .6.9a1 1 0 0 0 1.1-.2l.1-.1a1.9 1.9 0 0 1 2.7 0a1.9 1.9 0 0 1 0 2.7l-.1.1a1 1 0 0 0-.2 1.1a1 1 0 0 0 .9.6h.2a2 2 0 0 1 2 2v1.5a2 2 0 0 1-2 2h-.2a1 1 0 0 0-.9.6Z"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <div class="profile-header">
        <div>
          <h1>{{ user?.FIO || 'Пользователь' }}</h1>
          <p class="muted">Вы вошли в аккаунт</p>
        </div>
      </div>

      <div class="grid">
        <div class="info-box">
          <span>Email</span>
          <strong>{{ user?.email || '—' }}</strong>
        </div>

        <div class="info-box">
          <span>Телефон</span>
          <strong>{{ user?.phone || '—' }}</strong>
        </div>
      </div>

      <div class="support-box">
        <div class="support-icon">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M4 13a8 8 0 1 1 16 0v4a2 2 0 0 1-2 2h-2v-6h4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 13v4a2 2 0 0 0 2 2h2v-6H4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 19v2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
        </div>

        <div>
          <div class="support-title">Техподдержка</div>
          <a class="support-phone" href="tel:+79648889905">+7-964-888-99-05</a>
        </div>
      </div>
    </div>
		<div class="app-version">
			Версия приложения: 1.0.0
		</div>
  </div>
</template>

<script>
export default {
  name: 'ProfileView',
  computed: {
    user() {
      return this.$store.getters['auth/user']
    }
  }
}
</script>

<style scoped>
.page {
  padding: 12px;
}

.card {
  max-width: 760px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 22px;
  padding: 22px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
}

.profile-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.badge {
  display: inline-block;
  background: #dbeafe;
  color: #1d4ed8;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 700;
	border: none;
	background: #eef2ff;
	color: #1d4ed8;
	padding: 12px 14px;
	border-radius: 12px;
	font-weight: 700;
	cursor: pointer;
}

.settings-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 14px;
  background: #111827;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.settings-btn svg {
  width: 22px;
  height: 22px;
}

.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
}

h1 {
  margin: 0 0 8px;
  font-size: 30px;
}

.muted {
  margin: 0;
  color: #6b7280;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.info-box {
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 18px;
}

.info-box span {
  display: block;
  color: #6b7280;
  margin-bottom: 8px;
}

.support-box {
  margin-top: 18px;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  background: #f8fafc;
}

.support-icon {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: #111827;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.support-icon svg {
  width: 26px;
  height: 26px;
}

.support-title {
  font-weight: 800;
  margin-bottom: 6px;
}

.support-phone {
  color: #2563eb;
  font-weight: 800;
}

.app-version {
	padding: 22px 22px;
	opacity: 0.3;
	max-width: 760px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .profile-header {
    flex-direction: column;
  }

  .grid {
    grid-template-columns: 1fr;
  }
}
</style>